var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{ref:"audio",attrs:{"id":"audio_player","src":_vm.currentSong.play_song.play_address,"loop":""},on:{"timeupdate":_vm.onTimeChange}})}
var staticRenderFns = []

export { render, staticRenderFns }